export default "__VITE_PUBLIC_ASSET__0e8163f5__"